import { css } from '@emotion/react';
import { applyFont, tokens } from '@domain-group/fe-brary';

export const title = css`
  ${applyFont(tokens.typography.displayLarge)};
  color: ${tokens.colors.primary.medium.default};
  margin-bottom: ${tokens.spacing.l};
`;

export const subTitle = css`
  color: ${tokens.colors.primary.base.default};
`;

export const trustSignals = css`
  display: flex;
  justify-content: center;
  gap: ${tokens.spacing.l};
  margin-top: ${tokens.spacing.m};
`;

export const trustItem = css`
  display: flex;
  align-items: center;
  gap: ${tokens.spacing.xs};
`;

export const trustItemLabel = css`
  ${applyFont(tokens.typography.caption)};
`;
